import { StyledContainer } from './VehicleCardStorage.styled';

const VehicleCardStorage = ({ amount }: { amount: number }) => {
	if (amount === 0) {
		return null;
	}

	return (
		<StyledContainer>
			<span>{amount.toLocaleString('ru-RU')}</span>
			<span>&#160;с.</span>
		</StyledContainer>
	);
};

export { VehicleCardStorage };
